import React from "react";
import "./GridCell.css";
import { Cell } from "../lib/Game";

interface GridCellProps {
  cell: Cell
}

const GridCell: React.FC<GridCellProps> = ({ cell }) => {
  return <div className="grid-cell">
    {cell.value}
  </div>;
}

export default GridCell;